import styled from 'styled-components'

export const Button = styled.a.attrs(() => ({
  target: '_blank',
  rel: 'noopener',
}))`
  display: block;
  border: 2px solid #e00034;
  width: auto;
  padding: 13px 28px;
  text-align: center;
  border-radius: 25px;
  color: #6e6259;
  text-decoration: none;
  line-height: 20px;
  font-size: 20px;
  &:hover {
    border-color #b8002b;
  }
`
